import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import DropdownMenu from "../../../App/Components/DropdownMenu/DropdownMenu";
import { AppFeatureLookup } from "../../../App/Constants/AbacConstants";
import { crmLiteUpgradeMessage } from "../../../App/Constants/CrmLiteConstants";
import { useImportCandidateCSVMutation } from "../../../App/Queries/ImportQueries";
import { useFeaturePermission } from "../../../App/State/Hooks/abacHooks";
import { useImportStatusStore } from "../../../App/State/Stores/ImportStatusStore";
import { useManageCandidateSelectionContext } from "../../State/ManageCandidateContext";

export const ManageCandidatesButton = () => {
  const navigate = useNavigate();
  const showImportStatusText = useImportStatusStore((state) => state.showImportStatusText);
  const setShowImportModal = useImportStatusStore((state) => state.setShowImportModal);
  const { isLoading: isUploadLoading } = useImportCandidateCSVMutation();
  const importCandidatesButtonAccess = useFeaturePermission(AppFeatureLookup.CandidatesImportCandidatesByCsv);
  const disabled = useMemo(
    () => isUploadLoading || !importCandidatesButtonAccess,
    [isUploadLoading, importCandidatesButtonAccess],
  );
  const {
    getters: { selectedCount, isAddToGroupOpen },
    setters: { setAddToGroupOpen, setAddCandidateOpen },
  } = useManageCandidateSelectionContext();

  let tooltipMessage = "Import candidates by CSV";
  if (showImportStatusText || isUploadLoading) {
    tooltipMessage = "Please wait for the current import to finish";
  } else if (!importCandidatesButtonAccess) {
    tooltipMessage = crmLiteUpgradeMessage;
  }

  const addToGroupButtonAccess = useFeaturePermission(AppFeatureLookup.CandidatesAddCandidatesToGroup);
  let addToGroupTooltip = addToGroupButtonAccess
    ? "Select candidates to add to a group"
    : crmLiteUpgradeMessage;
  if (selectedCount > 0) {
    addToGroupTooltip = `Add ${selectedCount} selected candidate(s) to a group`;
  }

  const handleToggleAddToGroup = () => {
    if (!addToGroupButtonAccess) {
      return;
    }
    setAddToGroupOpen(!isAddToGroupOpen);
  };

  return (
    <DropdownMenu
      buttonLabel="Manage Candidates"
      tooltipText="Manage candidate options"
      menuDataTest="candidates-dropdown-button"
      sx={{ height: 55, width: "100%" }}
      menuItems={[
        {
          label: "Import Candidates",
          onClick: () => (disabled ? null : setShowImportModal(true)),
          disabled,
          title: tooltipMessage,
          dataTest: "open-csv-modal-button",
        },
        {
          label: "View Imports",
          onClick: () => navigate("/candidates/imports"),
          dataTest: "view-imports-button",
        },
        {
          label: "Add Single Candidate",
          onClick: () => setAddCandidateOpen(true),
          dataTest: "add-single-candidate-button",
        },
        {
          label: "Add Selected to Group",
          onClick: handleToggleAddToGroup,
          disabled: !addToGroupButtonAccess || !selectedCount,
          title: addToGroupTooltip,
          dataTest: "filter-button-add-to-group",
        },
      ]}
    />
  );
};
